const ServiceURL={
    GET_ALL_STARS:"game/getAllStars", // 获取星星总数
    GET_CHECK_POINTER:"checkPointer/getCheckPointer",// 进入关卡前获取关卡信息
    GET_PLAYER_CHECK_POINTER:"checkPointer/getPlayerCheckPointer",// 获取用户当前的关卡数
    QUERY_USER_INFO:"game/queryUserGameInfo",// 获取当前登陆用户信息
    GET_FINAL_COUNT_DOWN:"game/finalCountdown",// 获取当前进入的游戏的倒计时
    UPDATE_GAME_INFO:"game/updateGameInfo",// 更新并上传当前关卡信息
    USER_LOGIN:"user/userLogin",// 用户登陆，在本地测试专用
    USER_CHANNEL_LOGIN:"user/channel/userLogin",// 用户登陆，在本地测试专用
    ENTER_GAME:"user/enterGame",// 用户进入特定的游戏，本地测试专用
};
export default ServiceURL;


// WEBPACK FOOTER //
// ./src/service/ServerURL.js